import { render, staticRenderFns } from "./MatchesTab.vue?vue&type=template&id=2c0cb896"
import script from "./MatchesTab.vue?vue&type=script&setup=true&lang=js"
export * from "./MatchesTab.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports